module.exports = __webpack_public_path__ + "img/1.1b7a5af1.png";